import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import SoundStringBuilder, { splitSoundString } from '../SoundString/SoundStringBuilder';

// Совместимая обёртка над конструктором озвучки для старых экранов
// (Настройки → Параметры сервера): своя кнопка «Сохранить»
// и onSave с массивом { value, name }, как раньше.
function MultiSelect({ data, value, onSave }) {
  const [draft, setDraft] = useState(value || '');

  useEffect(() => {
    setDraft(value || '');
  }, [value]);

  const save = () => {
    const known = (data || []).flat();
    onSave(splitSoundString(draft).map((token) => (
      known.find((item) => item.value === token) || { value: token, name: token }
    )));
  };

  return (
    <div>
      <SoundStringBuilder data={data} value={draft} onChange={setDraft} />
      <Button type="primary" style={{ marginTop: 12 }} disabled={draft === (value || '')} onClick={save}>
        Сохранить
      </Button>
    </div>
  );
}

export default MultiSelect;
